import { Injectable, Type } from '@angular/core';
import { AbstractDialogService, canDismissWhenNotSwiped, DialogOptions } from '@examdojo/core/dialog';
import { ChallengeReviewDialogComponent } from './challenge-review-dialog.component';

export const CHALLENGE_REVIEW_DIALOG_ID = 'challenge-review-dialog';

export interface ChallengeReviewDialogInput {
  challengeActivityId: string;
}

@Injectable({ providedIn: 'root' })
export class ChallengeReviewDialogService extends AbstractDialogService<
  ChallengeReviewDialogInput,
  boolean,
  Type<ChallengeReviewDialogComponent>
> {
  readonly id = CHALLENGE_REVIEW_DIALOG_ID;
  protected readonly component = ChallengeReviewDialogComponent;

  override options: DialogOptions = {
    cssClass: 'modified-modal font-primary fullscreen',
    backdropDismiss: false,
    handle: false,
    breakpoints: undefined,
    initialBreakpoint: undefined,
    canDismiss: canDismissWhenNotSwiped,
  };

  async openReviewDialog(challengeActivityId: string): Promise<void> {
    this.assignComponentProperty('challengeActivityId', challengeActivityId);
    await this.openDialog({ input: { challengeActivityId } });
  }
}
